import { ComponentRenderer } from 'app/src/features/Proposals/components/ComponentRenderer'
import { pageconfigurationsApi } from 'app/src/services/welfareportal'
import { PageWidget } from 'app/src/shared/components'
import { useComponentRenderer, usePageTitle, useTranslation, useWebAppContext } from 'app/src/shared/hooks'
import { useEffect, useState, type ReactElement } from 'react'

export function Proposals(): ReactElement {
  const context = useWebAppContext()
  const { getPage } = useComponentRenderer()
  const proposalsPageConfig = pageconfigurationsApi.usePageRequestGet(
    {
      pathParams: { id: 'proposal', templateBasePath: context.userInfo.welfareCampaign.configuration.frontend.templateId },
    },
    { meta: { context } },
  )
  const { t } = useTranslation('proposal')
  usePageTitle(t('Proposal.SuggestSection.Title'))
  const [showHeader, setShowHeader] = useState(true)

  useEffect(() => {
    context.update({ breadCrumbItems: [] })

    // Evita loop su contesto
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleFinalStepCompleted = () => {
    setShowHeader(false)
  }

  return (
    <>
      {showHeader && (
        <PageWidget containerClassNamesOverrides='mb-1'>
          <h1 className='text-3xl font-bold'>{t('Proposal.SuggestSection.Title')}</h1>
        </PageWidget>
      )}
      {ComponentRenderer(getPage(proposalsPageConfig?.data), handleFinalStepCompleted)}
    </>
  )
}
